import React, { useEffect, useState } from "react";
import "./CSS/Main_dash.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  set_dashboard_data,
  set_external_trend_info,
  SET_FETCH_TAG_VALUE_CONTROL,
} from "../Action/Action";
import elektrik_renkli from "../Assets/Icons/elektrik_renkli.png";
import sıcak_su from "../Assets/Icons/hot-water.png";
import su from "../Assets/Icons/water-drop.png";

import Store from "../Store/Store";

const Popup = ({ x, y }) => {
  console.log(x, y);
};

const Main_Dash = (props) => {
  const hjsu = {
    marginRight: "6%", // Metnin boyutuyla aynı miktarda sağa kaydırma
  };

  let elek_gün_ = null;
  let elek_ay_ = null;
  let elek_yıl_ = null;
  let su_gün_ = null;
  let su_yıl_ = null;
  let su_ay_ = null;
  let sıcak_sugün_ = null;
  let sıcak_su_ay_ = null;
  let sıcak_su_yıl_ = null;

  const history = useHistory();
  const [state, Set_state] = useState([]);

  const [pop_up_style, Set_pop_up_style] = useState({
    position: "fixed",
    width: "100px",
    height: "150px",
    background: "white",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
  });

  const [misafir_oda, Set_misafir_oda] = useState({ misafir: 0, oda: 0 });

  let anlık_elektrik = "";
  let anlık_su = "";
  let anlık_sıcak_su = "";

  const showTagPopUp = (x_, y_) => {
    return <Popup x={x_} y={y_} />;
  };

  const [yillik_elek_dif, Set_yillik_elek_dif] = useState(0);
  const [yillik_su_dif, Set_yillik_su_dif] = useState(0);
  const [yillik_sicakSu_dif, Set_yillik_sicakSu_dif] = useState(0);

  useEffect(() => {
    const componentDidMount = async () => {

      /// Geçerli yılı al
      const currentYear = new Date().getFullYear();

      // Önceki yılın son günü (31 Aralık) tarihini oluştur
      const startDate = new Date(currentYear - 1, 11, 31, 0, 0, 0, 0); // Geçen yıl 31 Aralık 00:00:00.000

      // startDate'i formatla
      const formattedStartDate = startDate.toISOString().split('T')[0] + ' 00:00:00.000';

      // EndDate: Dün 23:59:59
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      // endDate'i formatla
      const formattedEndDate = yesterday.toISOString().split('T')[0] + ' 23:59:59.999';


      const token = sessionStorage.getItem('jwt_token');
      const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

      try {
        const request = await fetch(
          "https://app-rmmsapi.azurewebsites.net/api/tags/GetLimitedTagValueYear",
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              ...authHeader,
            },
            method: "POST",
            body: JSON.stringify({
              TagId: "557",
              StartDate: formattedStartDate,
              EndDate: formattedEndDate,
            }),
          }
        );

        const response = await request.json();

        let last_value = response.value[response.value.length - 1].tagValue;
        last_value = Number(last_value);
        Set_yillik_elek_dif(last_value);
      } catch (err) {
        console.log(err);
      }

      try {
        const request = await fetch(
          "https://app-rmmsapi.azurewebsites.net/api/tags/GetLimitedTagValueYear",
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              ...authHeader,
            },
            method: "POST",
            body: JSON.stringify({
              TagId: "5011",
              StartDate: formattedStartDate,
              EndDate: formattedEndDate,
            }),
          }
        );

        const response = await request.json();

        let last_value = response.value[response.value.length - 1].tagValue;
        last_value = Number(last_value);
        Set_yillik_su_dif(last_value);
      } catch (err) {
        console.log(err);
      }

      try {
        const request = await fetch(
          "https://app-rmmsapi.azurewebsites.net/api/tags/GetLimitedTagValueYear",
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              ...authHeader,
            },
            method: "POST",
            body: JSON.stringify({
              TagId: "5023",
              StartDate: formattedStartDate,
              EndDate: formattedEndDate,
            }),
          }
        );

        const response = await request.json();
        let last_value = response.value[response.value.length - 1].tagValue;
        last_value = Number(last_value) / 1000; // Birim uyumu için 1000'e böl
        Set_yillik_sicakSu_dif(last_value);
      } catch (err) {
        console.log(err);
      }
    };

    componentDidMount();
  }, []);

  useEffect(() => {
    console.log(props.misafir_oda);
    Set_misafir_oda(props.misafir_oda);
  }, [props.misafir_oda]);

  useEffect(() => {
    console.log(props.dash_datas, anlık_elektrik, anlık_su, anlık_sıcak_su);
    Set_state(props.dash_datas);
  }, [props.dash_datas]);

  // Dashboard data fetch interval with proper cleanup
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = sessionStorage.getItem('jwt_token');
        const response = await fetch(
          "https://app-rmmsapi.azurewebsites.net/api/pages/GetDashboard",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
          }
        );
        const data = await response.json();
        Store.dispatch(set_dashboard_data(data));
      } catch (err) {
        console.log("Dashboard fetch error:", err);
      } finally {
        Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
      }
    };

    // Initial fetch after 1 second
    const timeoutId = setTimeout(fetchDashboardData, 1000);

    // Set interval every 35 seconds (was 3.5s - too frequent)
    const intervalId = setInterval(fetchDashboardData, 35000);

    // Cleanup on unmount
    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, []);

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

   const [alarm_okuma, Set_alarm_okuma] = useState(false)
  
    useEffect(() => {
      if (props.yetkilendirme && props.uid !== "") {
        let data = props.yetkilendirme;
        let newObj = data[props.uid];
        if (newObj !== undefined) {
         
          if (newObj["Alarm"]["O"] === "t") {
  
            Set_alarm_okuma(true)
          } else {
            Set_alarm_okuma(false);
  
          }
        }
  
      }
    }, [props.uid])

  const [alarm_list, SetAlarm_List] = useState([]);
  const [noti_list, SetNoti_list] = useState([]);
  const [loading, SetLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      const ComponentDidMount = async () => {
        try {
          const token = sessionStorage.getItem('jwt_token');
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetNotificationList",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                ...(token && { Authorization: `Bearer ${token}` }),
              },
              body: JSON.stringify({
                companyId: props.ucer_id,
              }),
            }
          );

          const response = await request.json();
          SetNoti_list(response);
        } catch (err) {
          console.log(err);
          SetLoading(true);
        }
      };
      ComponentDidMount();
    }, 80);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const componentDidMount = async () => {
        try {
          const token = sessionStorage.getItem('jwt_token');
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetAlarmList",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                ...(token && { Authorization: `Bearer ${token}` }),
              },
              body: JSON.stringify({
                companyId: props.ucer_id,
              }),
            }
          );

          const response = await request.json();
          let newdata = [];

          if (request.status === 200) {
            response.forEach((x) => {
              if (x.confirm_ !== 1) {
                newdata.push(x);
              }
            });
            SetAlarm_List(newdata);
          }

          SetLoading(false);
        } catch (err) {
          console.log(err);
          SetLoading(true);
        }
      };
      componentDidMount();
    }, 80);
  }, []);

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(()=>{console.warn(misafir_oda)},[misafir_oda])

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  const getFirstDayOfCurrentMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = "01";
    const time = "00:00:00.000";

    return `${year}-${month}-${day} ${time}`;
  };

  const getPreviousDayEndTime = () => {
    const now = new Date();
    const previousDay = new Date(now);
    previousDay.setDate(now.getDate() - 1);

    const year = previousDay.getFullYear();
    const month = String(previousDay.getMonth() + 1).padStart(2, "0");
    const day = String(previousDay.getDate()).padStart(2, "0");
    const time = "23:59:59.999";

    return `${year}-${month}-${day} ${time}`;
  };

  const getFirstDayOfCurrentYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = "01";
    const day = "01";
    const time = "00:00:00.000";
  
    return `${year}-${month}-${day} ${time}`;
  };
  
  const getCurrentTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()-1).padStart(2, "0");
    
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const milliseconds = String(now.getMilliseconds()).padStart(3, "0");
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  };

  

  const [aylık_toplam_misafir, Set_aylık_toplam_misafir] = useState(0);
  const [aylık_toplam_oda, Set_aylık_toplam_oda] = useState(0);

  const [yillik_toplam_misafir, Set_yillik_toplam_misafir] = useState(0);
  const [yillik_toplam_oda, Set_yillik_toplam_oda] = useState(0);

  const GetAylıkToplam = async (startDate, endDate) => {
    try {
      const token = sessionStorage.getItem('jwt_token');
      const _request_ = await fetch(
        "https://app-rmmsapi.azurewebsites.net/api/tags/GetSumMO",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify({
            startDate: startDate,
            endDate: endDate,
            companyId:String(props.temp_com_id)
          }),
        }
      );
      const response = await _request_.json();
      console.log(response);

      Set_aylık_toplam_misafir(response[0].misafir);
      Set_aylık_toplam_oda(response[0].oda);
    } catch (err) {
      console.log(err);
    }
  };

  const GetYillikToplam = async (startDate,endDate) => {
    try {
      const token = sessionStorage.getItem('jwt_token');
      const _request_ = await fetch(
        "https://app-rmmsapi.azurewebsites.net/api/tags/GetSumYO",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body:JSON.stringify({
            startDate: startDate,
            endDate: endDate,
            companyId:String(props.temp_com_id)
          }),
        }
      );
      const response = await _request_.json();
      console.log(response);

      Set_yillik_toplam_misafir(response[0].misafir);
      Set_yillik_toplam_oda(response[0].oda);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    GetAylıkToplam(getFirstDayOfCurrentMonth(), getPreviousDayEndTime());
    GetYillikToplam(getFirstDayOfCurrentYear(),getCurrentTime());
  }, []);



  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>

      <section className="main main_dashboard main_dashboard_section">
        <div></div>
        <div className="row elektrik-row">
          <h4 className="title">ELEKTRİK TÜKETİMLERİ</h4>

          {state.map((item, index) => {
            if (item.tagId === "557") {
              if (item.tip === "Günlük") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_gün_ = anlık_elektrik;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Aylık") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_ay_ = anlık_elektrik;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Yıllık") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_elektrik = String(last_değer2).replaceAll(",", ".");

                elek_yıl_ = Number(anlık_elektrik).toFixed(2);

                console.log(anlık_elektrik,yillik_elek_dif);

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (
                elek_gün_ !== null &&
                elek_ay_ !== null &&
                elek_yıl_ !== null
              ) {
                return (
                  <div
                    onContextMenu={(e) => {
                      e.preventDefault();
                      const { clientX, clientY } = e;
                      console.log(clientX, clientY, item);
                      document
                        .querySelector(".show_external_trend")
                        .classList.toggle("show_external_trend_active");
                      document.querySelector(".show_tagId").innerHTML =
                        item.tagId;
                      document.querySelector(".show_tagName").innerHTML =
                        tagName;

                      var popup = document.querySelector(
                        ".show_external_trend"
                      );
                      const popupRect = popup.getBoundingClientRect();
                      const viewportWidth = window.innerWidth;
                      const viewportHeight = window.innerHeight;

                      // Calculate the new positions
                      let newX = clientX;
                      let newY = clientY;

                      // Adjust if the popup would overflow the right edge of the viewport
                      if (newX + popupRect.width > viewportWidth) {
                        newX = viewportWidth - popupRect.width;
                      }

                      // Adjust if the popup would overflow the bottom edge of the viewport
                      if (newY + popupRect.height > viewportHeight) {
                        newY = viewportHeight - popupRect.height;
                      }

                      // Adjust if the popup would overflow the left edge of the viewport
                      if (newX < 0) {
                        newX = 0;
                      }

                      // Adjust if the popup would overflow the top edge of the viewport
                      if (newY < 0) {
                        newY = 0;
                      }

                      // Set the position of the popup
                      popup.style.left = `${newX}px`;
                      popup.style.top = `${newY}px`;

                      showTagPopUp(clientX, clientY);
                    }}
                    className="box"
                  >
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Günlük : "}
                      <h4>{elek_gün_ + " " + item.tagUnit}</h4>
                    </p>
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Aylık : "}
                      <h4>{elek_ay_ + " " + item.tagUnit}</h4>
                    </p>
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Yıllık : "}
                      <h4>{elek_yıl_ + " " + item.tagUnit}</h4>
                    </p>
                  </div>
                );
              }
            }
          })}

          <div className="kisibasi">
            <p>Kişi Başı</p>
          </div>
          <div className="box4">
            <div className="div kat_basi">
              <h4 className="box4-gunayyil">Günlük</h4>
              <div className="value">
                { misafir_oda!==undefined && misafir_oda.misafir !== 0 &&
                  (Number(elek_gün_) / misafir_oda.misafir).toFixed(4)}{" "}
                kWh
              </div>
            </div>
            <div className="odabasi">
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
                 {misafir_oda!==undefined && misafir_oda.oda !== 0 &&
                  (Number(elek_gün_) / misafir_oda.oda).toFixed(4)}{" "}
                kWh
              </div>
            </div>
          </div>
          <div className="box4">
            <div className="div kat_basi">
              <h4 className="box4-gunayyil">Aylık</h4>
              <div className="value">
                {aylık_toplam_misafir&&aylık_toplam_misafir !== 0 ?
                  (Number(elek_ay_) / aylık_toplam_misafir).toFixed(4) : "0.00"}{" "}
                kWh
              </div>
            </div>
            <div className="odabasi" style={{ opacity: 0 }}>
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
                { aylık_toplam_oda&&aylık_toplam_oda !== 0 ?
                  (Number(elek_ay_) / aylık_toplam_oda).toFixed(4) : "0.00"}{" "}
                kWh
              </div>
            </div>
          </div>
          <div className="box4">
            <div className="div kat_basi">
              <h4 className="box4-gunayyil">Yıllık</h4>
              <div className="value">
                {yillik_toplam_misafir&&yillik_toplam_misafir !== 0 &&
                  (
                    (Number(elek_yıl_)) /
                    yillik_toplam_misafir
                  ).toFixed(4)}{" "}
                kWh
              </div>
            </div>
            <div className="odabasi" style={{ opacity: 0 }}>
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
                {yillik_toplam_oda&&yillik_toplam_oda !== 0 &&
                  (
                    (Number(elek_yıl_)) /
                    yillik_toplam_oda
                  ).toFixed(4)}{" "}
                kWh
              </div>
            </div>
          </div>
        </div>
        <div className="row su-row">
          <h4 className="title">SU TÜKETİMLERİ</h4>
          {state.map((item, index) => {
            if (item.tagId === "5011") {
              if (item.tip === "Günlük") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_su = String(last_değer2).replaceAll(",", ".");

                su_gün_ = anlık_su;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Aylık") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_su = String(last_değer2).replaceAll(",", ".");

                su_ay_ = anlık_su;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Yıllık") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_su = String(last_değer2).replaceAll(",", ".");

                su_yıl_ = anlık_su;

                console.log(su_yıl_);

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (su_gün_ !== null && su_ay_ !== null && su_yıl_ !== null) {
                return (
                  <div
                    onContextMenu={(e) => {
                      e.preventDefault();
                      const { clientX, clientY } = e;
                      console.log(clientX, clientY);
                      document
                        .querySelector(".show_external_trend")
                        .classList.toggle("show_external_trend_active");
                      document.querySelector(".show_tagId").innerHTML =
                        item.tagId;
                      document.querySelector(".show_tagName").innerHTML =
                        tagName;

                      var popup = document.querySelector(
                        ".show_external_trend"
                      );
                      const popupRect = popup.getBoundingClientRect();
                      const viewportWidth = window.innerWidth;
                      const viewportHeight = window.innerHeight;

                      // Calculate the new positions
                      let newX = clientX;
                      let newY = clientY;

                      // Adjust if the popup would overflow the right edge of the viewport
                      if (newX + popupRect.width > viewportWidth) {
                        newX = viewportWidth - popupRect.width;
                      }

                      // Adjust if the popup would overflow the bottom edge of the viewport
                      if (newY + popupRect.height > viewportHeight) {
                        newY = viewportHeight - popupRect.height;
                      }

                      // Adjust if the popup would overflow the left edge of the viewport
                      if (newX < 0) {
                        newX = 0;
                      }

                      // Adjust if the popup would overflow the top edge of the viewport
                      if (newY < 0) {
                        newY = 0;
                      }

                      // Set the position of the popup
                      popup.style.left = `${newX}px`;
                      popup.style.top = `${newY}px`;

                      showTagPopUp(clientX, clientY);
                    }}
                    className="box"
                  >
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Günlük : "} <h4>{su_gün_ + " m³"}</h4>
                    </p>
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Aylık : "} <h4>{su_ay_ + " m³"}</h4>
                    </p>
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Yıllık : "} <h4>{su_yıl_ + " m³"}</h4>
                    </p>
                  </div>
                );
              }
            }
          })}

          <div className="kisibasi">
            <p>Kişi Başı</p>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <div className="value">
                {misafir_oda!==undefined &&misafir_oda.misafir !== 0 &&
                  (Number(su_gün_) / misafir_oda.misafir).toFixed(4)}{" "}
                m³
              </div>
            </div>
            <div className="odabasi">
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
                {misafir_oda!==undefined && misafir_oda.oda !== 0 &&
                  (Number(su_gün_) / misafir_oda.oda).toFixed(4)}{" "}
                m³
              </div>
            </div>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <div className="value">
                {aylık_toplam_misafir&&aylık_toplam_misafir !== 0 ?
                  (Number(su_ay_) / aylık_toplam_misafir).toFixed(4) : "0.00"}{" "}
                m³
              </div>
            </div>
            <div className="odabasi" style={{ opacity: 0 }}>
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
                {aylık_toplam_oda&&aylık_toplam_oda !== 0 ?
                  (Number(su_ay_) / aylık_toplam_oda).toFixed(4) : "0.00"}{" "}
                m³
              </div>
            </div>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <div className="value">
                {yillik_toplam_misafir && yillik_toplam_misafir !== 0 &&
                  (Number(su_yıl_) / yillik_toplam_misafir).toFixed(4)}{" "}
                m³
              </div>
            </div>
            <div className="odabasi" style={{ opacity: 0 }}>
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
                {yillik_toplam_oda && yillik_toplam_oda !== 0 &&
                  (Number(su_yıl_) / yillik_toplam_oda).toFixed(4)}{" "}
                m³
              </div>
            </div>
          </div>
        </div>
        <div className="row sicaksu-row">
          <h4 className="title"> SICAK SU TÜKETİMLERİ</h4>
          {state.map((item, index) => {
            if (item.tagId === "5023") {
              if (item.tip === "Günlük") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_sıcak_su = String(last_değer2).replaceAll(",", ".");

                sıcak_sugün_ = anlık_sıcak_su;

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Aylık") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_sıcak_su = String(last_değer2).replaceAll(",", ".");

                sıcak_su_ay_ = anlık_sıcak_su;
                sıcak_su_ay_ = Math.abs(sıcak_su_ay_).toFixed(2)

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (item.tip === "Yıllık") {
                function formatNumber(number) {
                  // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                  const parts = number.toString().split(".");
                  // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                  if (parts[1]) {
                    parts[1] = parts[1].padEnd(2, "0");
                  } else {
                    parts.push("00");
                  }
                  // Parçaları birleştirip sonucu döndürme
                  return parts.join(",");
                }
                var tagName = props.tags
                  .filter((b) => b.tagId === item.tagId)
                  .map((c) => c.tagName)[0];
                console.log(tagName);
                var değer = item.tagValue;
                değer = değer.replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                let last_değer = formatNumber(değer);
                let last_değer2 = String(last_değer).replaceAll(".", "");
                anlık_sıcak_su = String(last_değer2).replaceAll(",", ".");

                sıcak_su_yıl_ = Number(anlık_sıcak_su).toFixed(2);

                console.log(sıcak_su_yıl_);

                item.tagUnit = item.tagUnit !== null ? item.tagUnit : "";
              }
              if (
                sıcak_sugün_ !== null &&
                sıcak_su_ay_ !== null &&
                sıcak_su_yıl_ !== null
              ) {
                return (
                  <div
                    onContextMenu={(e) => {
                      e.preventDefault();
                      const { clientX, clientY } = e;
                      console.log(clientX, clientY);
                      document
                        .querySelector(".show_external_trend")
                        .classList.toggle("show_external_trend_active");
                      document.querySelector(".show_tagId").innerHTML =
                        item.tagId;
                      document.querySelector(".show_tagName").innerHTML =
                        tagName;

                      var popup = document.querySelector(
                        ".show_external_trend"
                      );
                      const popupRect = popup.getBoundingClientRect();
                      const viewportWidth = window.innerWidth;
                      const viewportHeight = window.innerHeight;

                      // Calculate the new positions
                      let newX = clientX;
                      let newY = clientY;

                      // Adjust if the popup would overflow the right edge of the viewport
                      if (newX + popupRect.width > viewportWidth) {
                        newX = viewportWidth - popupRect.width;
                      }

                      // Adjust if the popup would overflow the bottom edge of the viewport
                      if (newY + popupRect.height > viewportHeight) {
                        newY = viewportHeight - popupRect.height;
                      }

                      // Adjust if the popup would overflow the left edge of the viewport
                      if (newX < 0) {
                        newX = 0;
                      }

                      // Adjust if the popup would overflow the top edge of the viewport
                      if (newY < 0) {
                        newY = 0;
                      }

                      // Set the position of the popup
                      popup.style.left = `${newX}px`;
                      popup.style.top = `${newY}px`;

                      showTagPopUp(clientX, clientY);
                    }}
                    className="box"
                  >
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Günlük : "} <h4>{sıcak_sugün_ + " m³"}</h4>
                    </p>
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Aylık : "} <h4>{sıcak_su_ay_ + " m³"}</h4>
                    </p>
                    <p
                      style={{
                        margin: -5,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {"Yıllık : "} <h4>{Math.ceil(sıcak_su_yıl_).toFixed(2) + " m³"}</h4>
                    </p>
                  </div>
                );
              }
            }
          })}

          <div className="kisibasi">
            <p>Kişi Başı</p>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <div className="value">
              {misafir_oda!==undefined &&misafir_oda.misafir !== 0 &&
                  (Number(sıcak_sugün_) / misafir_oda.misafir).toFixed(4)}{" "}
                m³
              </div>
            </div>
            <div className="odabasi">
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
              {misafir_oda!==undefined &&misafir_oda.oda !== 0 &&
                  (Number(sıcak_sugün_) / misafir_oda.oda).toFixed(4)}{" "}
                m³
              </div>
            </div>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <div className="value">
                {aylık_toplam_misafir&&aylık_toplam_misafir !== 0 ?
                  (Number(sıcak_su_ay_) / aylık_toplam_misafir).toFixed(4) : "0.00"}{" "}
                m³
              </div>
            </div>
            <div className="odabasi" style={{ opacity: 0 }}>
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
                {aylık_toplam_oda&&aylık_toplam_oda !== 0 ?
                  (Number(sıcak_su_ay_) / aylık_toplam_oda).toFixed(4) : "0.00"}{" "}
                m³
              </div>
            </div>
          </div>
          <div className="box4 special">
            <div className="div kat_basi">
              <div className="value">
                {yillik_toplam_misafir&&yillik_toplam_misafir !== 0 &&
                  (
                    (Number(sıcak_su_yıl_)) /
                    yillik_toplam_misafir
                  ).toFixed(4)}{" "}
                m³
              </div>
            </div>
            <div className="odabasi" style={{ opacity: 0 }}>
              <p>Oda Başı</p>
            </div>
            <div className="div oda_basi">
              <div className="value">
                {yillik_toplam_oda&&yillik_toplam_oda !== 0 &&
                  (
                    (Number(sıcak_su_yıl_)) /
                    yillik_toplam_oda
                  ).toFixed(4)}{" "}
                m³
              </div>
            </div>
          </div>
        </div>

        <div
          id="dashboard_bottom_row"
          style={{ justifyContent: "flex-start" }}
          className="row"
        >
          <div className="title_dash_alarms">ALARMLAR</div>
          <div
            onClick={() => {
              if(alarm_okuma) history.push("/Alarmpanel");
            }}

            className="kritik_alarm event_alarm"
          >
            <p>Alarms: </p>
            <h5>{alarm_list.length}</h5>
          </div>
          <div
            style={{ opacity: "0" }}
            onClick={() => {
              history.push("/notifications");
            }}
            className="toplam_alarm alarm_alarm"
          >
            <p>Event: </p>
            <h5>{alarm_list.length + props.noti_list.length}</h5>
          </div>
          <div className="box4 special alarmbox4">
            <div
              onContextMenu={(e) => {
                e.preventDefault();
                const { clientX, clientY } = e;
                console.log(clientX, clientY);
                document
                  .querySelector(".show_external_trend")
                  .classList.toggle("show_external_trend_active");
                document.querySelector(".show_tagId").innerHTML = "5024";
                document.querySelector(".show_tagName").innerHTML =
                  "Endüktif Oran";

                var popup = document.querySelector(".show_external_trend");
                const popupRect = popup.getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;

                // Calculate the new positions
                let newX = clientX;
                let newY = clientY;

                // Adjust if the popup would overflow the right edge of the viewport
                if (newX + popupRect.width > viewportWidth) {
                  newX = viewportWidth - popupRect.width;
                }

                // Adjust if the popup would overflow the bottom edge of the viewport
                if (newY + popupRect.height > viewportHeight) {
                  newY = viewportHeight - popupRect.height;
                }

                // Adjust if the popup would overflow the left edge of the viewport
                if (newX < 0) {
                  newX = 0;
                }

                // Adjust if the popup would overflow the top edge of the viewport
                if (newY < 0) {
                  newY = 0;
                }

                // Set the position of the popup
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;

                showTagPopUp(clientX, clientY);
              }}
              className="div kat_basi end-oran"
            >
              <p>End.Oran</p>
              <div className="value">
                {props.tag_values.find((x) => x.tagId === "5024")?.tagValue}
              </div>
            </div>
          </div>
          <div className="box4 special alarmbox4">
            <div
              onContextMenu={(e) => {
                e.preventDefault();
                const { clientX, clientY } = e;
                console.log(clientX, clientY);
                document
                  .querySelector(".show_external_trend")
                  .classList.toggle("show_external_trend_active");
                document.querySelector(".show_tagId").innerHTML = "5025";
                document.querySelector(".show_tagName").innerHTML =
                  "Kapasitif Oran";

                var popup = document.querySelector(".show_external_trend");
                const popupRect = popup.getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;

                // Calculate the new positions
                let newX = clientX;
                let newY = clientY;

                // Adjust if the popup would overflow the right edge of the viewport
                if (newX + popupRect.width > viewportWidth) {
                  newX = viewportWidth - popupRect.width;
                }

                // Adjust if the popup would overflow the bottom edge of the viewport
                if (newY + popupRect.height > viewportHeight) {
                  newY = viewportHeight - popupRect.height;
                }

                // Adjust if the popup would overflow the left edge of the viewport
                if (newX < 0) {
                  newX = 0;
                }

                // Adjust if the popup would overflow the top edge of the viewport
                if (newY < 0) {
                  newY = 0;
                }

                // Set the position of the popup
                popup.style.left = `${newX}px`;
                popup.style.top = `${newY}px`;

                showTagPopUp(clientX, clientY);
              }}
              className="div kat_basi kap-oran"
            >
              <p>Kap.Oran</p>
              <div className="value">
                {props.tag_values.find((x) => x.tagId === "5025")?.tagValue}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    alarms: state.project_reducer.alarms,
    dash_datas: state.project_reducer.dashboard_datas,
    misafir_oda: state.project_reducer.misafir_oda,
    tags: state.project_reducer.tag_list,
    tag_values: state.project_reducer.tag_values,
    ucer_id: state.project_reducer.company_id,
    noti_list: state.project_reducer.notifications,
    temp_com_id: state.project_reducer.temp_com_id,
    uid: state.auth_reducer.user_id,

  };
};

export default connect(MapStateToProps)(Main_Dash);
